<div #backdrop *ngIf="currentMessage && currentMessage.options.Type"
    [ngClass]="{'backdrop':hasBackdrop(),'hideBackdrop':(!hasBackdrop && isIntervention())}">
    <div class="pgn-wrapper" [class.hide]="!show" [attr.data-position]="currentMessage.options.Position" [ngStyle]="style">
        <!-- <pg-message style="border-radius: 10px !important;transition: all 0.2s linear 0s;"
            *ngFor="let message of messages; let i = index" [Message]="message" [Index]="i"></pg-message> -->
    </div>
</div>
<div #backdrop *ngIf="currentMessage && !currentMessage.options.Type">
    <div class="pgn-wrapper" [class.hide]="!show" [attr.data-position]="currentMessage.options.Position" [ngStyle]="style">
        <!-- <pg-message style="border-radius: 10px !important;transition: all 0.2s linear 0s;"
            *ngFor="let message of messages; let i = index" [Message]="message" [Index]="i"></pg-message> -->
    </div>
</div>

<!-- <div  *ngIf="currentMessage && !currentMessage.options.Type">
	<div class="mess">
		testing
	</div>
</div> -->
